import "isomorphic-fetch"

export const postData = (url = ``, data = {}, options) => {
  // Default options are marked with *
  return fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, cors, *same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "omit", // include, same-origin, *omit
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "max-age=31536000",
      //   'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    redirect: "follow", // manual, *follow, error
    referrer: "no-referrer", // no-referrer, *client
    body: JSON.stringify(data), // body data type must match "Content-Type" header
    ...options,
  })
    .then(response => response.json()) // parses response to JSON
    .catch(error => console.error(`Fetch Error \n`, error))
}
